module.exports = __webpack_public_path__ + "static/media/notificacao.79d5cb69.svg";